/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_RevealInputs */

const en_field_reveal = /** @type {(inputs: Field_RevealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show`)
};

const de_field_reveal = /** @type {(inputs: Field_RevealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigen`)
};

/**
* | output |
* | --- |
* | "Show" |
*
* @param {Field_RevealInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const field_reveal = /** @type {((inputs?: Field_RevealInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_RevealInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_field_reveal(inputs)
	return en_field_reveal(inputs)
});